import { useEffect } from "react";

export const OpenWindowPrint = () => {
  const print = () => {
    setTimeout(() => window.print(), 300);
  }
  useEffect(() => { print() }, []);
  return null;
};